export * from "./dateUtils";
export * from "./errorHandling";

export function never<T>(_: never, value: T) {
  return value;
}
